const ArrowForward = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Arrow / arrow_forward">
      <path
        id="Vector"
        d="M9.5 3L8.4425 4.0575L12.6275 8.25H3.5V9.75H12.6275L8.4425 13.9425L9.5 15L15.5 9L9.5 3Z"
      />
    </g>
  </svg>
)

export default ArrowForward
